import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class CustomerChildrenResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerId = 0;
    }
    pk() {
        return this.customerId?.toString() || "";
    }
}
CustomerChildrenResource.urlRoot = apiResourceUrl("customer-children");
//# sourceMappingURL=CustomerChildrenResource.js.map